
import React, { Suspense } from 'react';
import { MetaTags } from '@/components/seo/MetaTags';
import { ToolLayout } from '@/components/tools/ToolLayout';
import { Skeleton } from '@/components/ui/skeleton';

// Import lazy pour optimiser le chargement
const TabliWizzApp = React.lazy(() => import('@/tools/tabliwizz'));

const TabliWizzPage = () => {
  return (
    <>
      <MetaTags 
        title="TabliWizz – Créez facilement vos graphiques à partir d'un tableur intuitif"
        description="Créez rapidement des graphiques professionnels à partir d'un tableur intuitif pour visualiser vos données."
      />
      <ToolLayout 
        title="TabliWizz | Générateur de graphiques à partir d'un tableur intuitif"
        description="Importez ou saisissez facilement des données dans un tableau interactif, puis créez instantanément des graphiques professionnels personnalisés."
        toolName="TabliWizz"
        maxWidth="7xl"
        reliabilityLevel={3}
        breadcrumbs={[
          { label: "Accueil", path: "/" },
          { label: "TabliWizz", path: "/tabliwizz" },
        ]}
      >
        <Suspense fallback={<Skeleton className="w-full h-[600px]" />}>
          <TabliWizzApp />
        </Suspense>
      </ToolLayout>
    </>
  );
};

export default TabliWizzPage;
